import React from 'react'
import { usePostRequest } from '../hooks/request'
import { ROTATION_LIST } from '../urls'
import RotationForm from './RotationForm'

export default function RotationCreate({ onCancel, onSuccess }) {
    const rotationCreate = usePostRequest({ url: ROTATION_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <RotationForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
